import { useCartStore } from '../../stores/cartStore';
import { logger } from 'common-ui';
import { fetchCart } from '../../services/cart';

export function useInitCartStateWithAtgLegacyApi() {
  return async (): Promise<void> => {
    const { cartItems } = useCartStore.getState().cart;
    if (cartItems) {
      logger.log('skipping init fetch of cart data as already defined');
      return;
    }
    await fetchCart();
  };
}
